const MenuFood = [
    {
        id: 1,
        MainImage: "https://media-cldnry.s-nbcnews.com/image/upload/newscms/2020_27/1586837/hotdogs-te-main-200702.jpg",
        name: "Hot dogs are not American",
        category: "Food-Facts",
        description:
            "It’s not clear where the hot dog originated from. Some say it was invented in the Austrian city",
    },
    {
        id: 2,
        MainImage: "https://fitwithfoodnet.files.wordpress.com/2020/07/dark-chocolate.jpg",
        name: "Dark chocolate benefits",
        category: "Food-Facts",
        description:
            "For improving bad cholesterol, lowering blood pressure, helping to reduce stress. Dark chocolates are too good",
    },
    {
        id: 3,
        MainImage: "https://pbs.twimg.com/media/DuDSKbLXgAASVWh.jpg",
        name: "Fruit salad trees are exist",
        category: "Food-Facts",
        description:
            "These multi-grafted trees were developed in Australia to grow up to six different types of fruit on one tree",
    },
    {
        id: 4,
        MainImage: "https://img.wonderhowto.com/img/72/01/63600304837491/0/spam-went-from-hated-ration-cult-classic.w1456.jpg",
        name: "Spam = Spice + Ham ?",
        category: "Food-Facts",
        description:
            "And not, as urban legend would say, Scientifically Processed Animal Matter. Spam is a mashup of the words Spice & Ham",
    },
    {
        id: 5,
        MainImage: "https://www.eatthis.com/wp-content/uploads/sites/4/2021/07/watermelon-1.jpg?quality=82&strip=1&resize=640%2C360",
        name: "Fruits reduces body fat ?",
        category: "Food-Facts",
        description:
            "Not all types of fruit but water based fruit like Watermelon, Graphs can do a better job. So start eating fruits from today",
    },
    {
        id: 6,
        MainImage: "https://img.onmanorama.com/content/dam/mm/en/food/features/images/2021/10/17/pizza.jpg",
        name: "The most expensive pizza",
        category: "Food-Facts",
        description:
            "That’s because it takes 72 hours to make, and it can only be made in your home by 3 Italian chefs. It costs $12,000 dollars",
    },
    {
        id: 7,
        MainImage: "https://media.distractify.com/brand-img/d8eD3pDhK/0x0/_why-do-crackers-have-holes-in-them-graham-1595275493466.jpg",
        name: "Why Crackers have holes ?",
        category: "Food-Facts",
        description:
            "During the baking process, if the crackers have holes in them, it prevents air bubbles from ruining the product",
    },
    {
        id: 8,
        MainImage: "https://images.healthshots.com/healthshots/en/uploads/2021/09/06153546/ketchup-1-1600x900.jpg",
        name: "Ketchup = medicine ?",
        category: "Food-Facts",
        description:
            "Back in the early 1800s, people thought tomatoes had medicinal qualities. So they used it as a medicine",
    },
    {
        id: 9,
        MainImage: "https://www.thespruceeats.com/thmb/oBowFQCbBldPUoSZ6g0Kr3PpD6o=/2164x1385/filters:no_upscale():max_bytes(150000):strip_icc()/ac_bnphotos-19a64ddc7b22445bb799ccf58de34b2e.jpg",
        name: "White chocos isn’t chocos",
        category: "Food-Facts",
        description:
            "It’s really just a mixture of sugar, milk, vanilla, lecithin, and cocoa butter, it doesn’t have any components of regular chocolate",
    },
    {
        id: 10,
        MainImage: "https://www.thefactsite.com/wp-content/uploads/2019/12/peanuts-dynamite.jpg",
        name: "Peanuts in Dynamite Bomb",
        category: "Food-Facts",
        description:
            "Peanuts have an oil that is used as an ingredient while making glycerol, which is a main component of nitroglycerin",
    },
];

export default MenuFood;